<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Button, Container, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	const dispatch = createEventDispatcher();
	export let weatherLocation: string | undefined;
</script>

<Container padding="0">
	<div class="d-flex justify-content-center">
		<img src="./images/premium-accoint-activated.svg" alt="congratulations" />
	</div>
	<Text class="text-center mt-m" element="h1">
		{$format('text_title_premium_congrats', {
			default: 'Congratulations, you are now a Premium User!',
		})}
	</Text>
	<Text class="text-center text-color-muted mt-m" styleType="body">
		{$format('text_desc_premium_congrats', {
			default:
				'You have successfully activated your premium account. Enjoy your premium benefits.',
		})}
	</Text>
	{#if weatherLocation && weatherLocation.length > 0}
		<div class="d-flex justify-content-center mt-m">
			<Button
				on:click={() => {
					dispatch('click');
				}}
			>
				{$format('button_got_it', {
					default: 'Okay, got it!',
				})}
			</Button>
		</div>
	{/if}
</Container>
